module.exports = __webpack_public_path__ + "static/media/GWE-PinwheelInstructions.2a28628b.pdf";